export const GET_PRIVATE_PERSONAL_DATA = 'GET_PRIVATE_PERSONAL_DATA';
